import {
  BrowserClient,
  Breadcrumbs,
  Dedupe,
  defaultStackParser,
  getCurrentHub,
  GlobalHandlers,
  makeFetchTransport,
  LinkedErrors,
} from "@sentry/browser";

const client = new BrowserClient({
  enabled: process.env.NODE_ENV === "production",
  dsn: "https://5ac76edc8d2e4110a7e8303eb908fe0c@o1432163.ingest.sentry.io/4504798887018496",
  tracesSampleRate: 0.2,
  transport: makeFetchTransport,
  stackParser: defaultStackParser,
  // Only the integrations listed here will be used
  integrations: [
    // new BrowserTracing(),
    new Breadcrumbs(),
    new GlobalHandlers(),
    new LinkedErrors(),
    new Dedupe(),
  ],
});

const hub = getCurrentHub();

getCurrentHub().bindClient(client);

export { client, hub };
